import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonRow,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { ECapabilities, EInvoiceState, EInvoiceType, IAccount } from '@okcargo-apps/shared-domain-ionic';
import { DateFnsModule } from 'ngx-date-fns';
import { Observable, Subscription } from 'rxjs';
import { AccountService } from '../../account/account.service';
import { DownloadDocumentService } from '../../download-document/download-document.service';
import { InvoiceService } from '../invoice.service';

@Component({
  selector: 'lib-invoices-list',
  templateUrl: './invoices-list.component.html',
  styleUrls: ['./invoices-list.component.scss'],
  imports: [
    IonItemDivider,
    IonItemGroup,
    CommonModule,
    IonIcon,
    IonButton,
    IonCol,
    IonRow,
    IonGrid,
    IonLabel,
    IonItem,
    IonList,
    TranslateModule,
    DateFnsModule,
  ],
})
export class InvoicesListComponent implements OnInit {
  private readonly invoiceService = inject(InvoiceService);
  private readonly accountService = inject(AccountService);
  private readonly downloadDocumentService = inject(DownloadDocumentService);

  @Input()
  type: EInvoiceType = EInvoiceType.PURCHASE;

  @Input()
  latest = false;

  isDesktopView$: Subscription = new Subscription();
  public isDesktop = false;

  public readonly ECapabilities = ECapabilities;
  public account$: Observable<IAccount>;

  public readonly EInvoiceType = EInvoiceType;
  public readonly EInvoiceState = EInvoiceState;

  public invoices$!: Observable<any>;

  constructor() {
    this.account$ = this.accountService.account$;
  }

  ngOnInit(): void {
    // we make sure we receive the value of @Input
    if (this.type === EInvoiceType.SALE) {
      this.invoices$ = this.invoiceService.invoicesSale$;
    } else {
      this.invoices$ = this.invoiceService.invoicesPurchase$;
    }
  }

  protected download(url: string): void {
    this.downloadDocumentService.downloadFile(url);
  }
}
